"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncGeneralSettingsContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var GeneralSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./GeneralSettingsContainer'
    /* webpackChunkName: "chunk-content-membership" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncGeneralSettingsContainer(props) {
  return _react.default.createElement(GeneralSettingsContainer, props);
}

module.exports = exports.default;